export const publicRoutes = [
    "/user/login",
    "/user/register",
    "/user/register/transporter",
    "/user/register/dealer",
    "/user/forgotPassword",
    "/user/reset-password",
    "/user/confirm-email",
];
